import { normalizarTexto } from "../../../utilities/textValidations.js";

export const existeTipoProductoDuplicado = (tipoProductos, descripcion) => {
  const descNormalized = normalizarTexto(descripcion);

  const lista = Array.isArray(tipoProductos) ? tipoProductos : [];
  return lista.some((tipo) => normalizarTexto(tipo.descripcion) === descNormalized);
};
